export default __webpack_public_path__ + "static/media/af8.ad2896f1.jpg";